import { useSyncExternalStore } from "react";
// Same key the old Layout used, so an existing user's choice survives the upgrade.
const COLLAPSED_KEY = "sidebarCollapsed";
const readCollapsed = () => {
    try {
        return localStorage.getItem(COLLAPSED_KEY) === "true";
    }
    catch (_a) {
        return false;
    }
};
let state = { collapsed: readCollapsed(), drawerOpen: false };
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn());
export const navStore = {
    getState: () => state,
    subscribe(fn) {
        listeners.add(fn);
        return () => {
            listeners.delete(fn);
        };
    },
    setCollapsed(collapsed) {
        if (state.collapsed === collapsed)
            return;
        state = Object.assign(Object.assign({}, state), { collapsed });
        try {
            localStorage.setItem(COLLAPSED_KEY, String(collapsed));
        }
        catch (_a) {
            /* private browsing — the preference just won't persist */
        }
        emit();
    },
    toggleCollapsed() {
        navStore.setCollapsed(!state.collapsed);
    },
    setDrawerOpen(drawerOpen) {
        if (state.drawerOpen === drawerOpen)
            return;
        state = Object.assign(Object.assign({}, state), { drawerOpen });
        emit();
    },
    toggleDrawer() {
        navStore.setDrawerOpen(!state.drawerOpen);
    },
};
export const useNavStore = () => useSyncExternalStore(navStore.subscribe, navStore.getState, navStore.getState);
